import React from "react";
import "./index.scss";

const Button = ({
  type = "button",
  label = "",
  variant = "primary",
  onClick,
  className,
  disabled = false,
  ...props
}) => {
  const btnVariantClass = () => {
    switch (variant) {
      case "primary":
        return "btn-primary";
      case "secondary":
        return "btn-secondary";
      case "outlined":
        return "btn-outlined";
      case "primaryBox":
        return "btn-primary-box";
      case "primaryOutlined":
        return "btn-primary-outlined";
      case "primaryNotOutlined":
        return "btn-primary-notoutlined";
      case "secondary-notOulined":
        return "btn-not-outlined";
      case "grey-outlined":
        return "btn-grey-outlined";
      case "btn-primary-link":
        return "btn-primary-link";
      default:
        return "btn-primary";
    }
  };
  return (
    <button
      type={type}
      className={`btn 
        ${btnVariantClass()} 
        ${className ? className : ""}
      `.trim()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {label}
    </button>
  );
};

export default Button;
